import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";

import { MARKETPLACE } from "../../helpers/constants";
import { IMG } from "../../themes";
import { Style } from "./style";

const android =
  "https://play.google.com/store/apps/details?id=com.magicboxasia.vich&pcampaignid=web_share";
const appleId = "https://apps.apple.com/th/app/vich/id1477822790";
const app = "vichai://";

function Marketplace() {
  const { language } = useSelector((state) => state.accountReducer);

  let autoOpenApp = null;

  useEffect(() => {
    if (window !== undefined && isMobile) {
      autoOpenApp = setTimeout(() => {
        window.location.href = app;
      }, 500);
    }

    return () => {
      clearTimeout(autoOpenApp);
    };
  }, []);

  return (
    <Style>
      <div>
        <div className="wrap-logo">
          <img src={IMG["vich-logo-square-gold.svg"]} alt="main logo" />
        </div>
        <div className="wrap-text">
          <h1>{MARKETPLACE[language].AVAILABLE_ON}</h1>
          <span>{MARKETPLACE[language].APP_STORE_AND_GOOGLE_PLAY}</span>
        </div>
        <div>
          <a href={appleId}>
            <img
              className="marketplace-app-store"
              src={IMG["app-store-badge.svg"]}
              alt="main logo"
            />
          </a>
        </div>
        <div>
          <a href={android}>
            <img
              className="marketplace-android"
              src={IMG["google-play-badge_512.png"]}
              alt="main logo"
            />
          </a>
        </div>
      </div>
    </Style>
  );
}

export default Marketplace;
